import React from 'react';
import styles from './marketing.module.css';
import { SEO, organizationJsonLd } from '../components/SEO.jsx';
import cityImage from '../pictures/Singapore Business District.avif';
import chainImage from '../pictures/MassiveChain.webp';
import officeImage from '../pictures/OldOffice.avif';

const currentYear = new Date().getFullYear();

export function About() {
  return (
    <main className={styles.page}>
      <SEO
        title="About Blockchain Systems"
        description="Blockchain Systems Pte. Ltd. builds patented Back-Step Blockchain technology for trusted digital records, products, services, and partner applications."
        path="/about"
        jsonLd={organizationJsonLd}
      />

      <section className={styles.hero}>
        <img className={styles.heroImage} src={cityImage} alt="Singapore business district" />
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <p className={styles.kicker}>Blockchain Systems Pte. Ltd.</p>
          <h1 className={styles.heroTitle}>Built in Singapore for organizations that need lasting trust.</h1>
          <p className={styles.heroText}>
            We develop Back-Step Blockchain products for companies, public institutions, and partners that need records customers can rely on for decades.
          </p>
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.split}>
          <div className={styles.splitCopy}>
            <span className={styles.tag}>Who we are</span>
            <h2>Hardware, software, and cryptography under one roof.</h2>
            <p>
              Blockchain Systems is a privately owned company focused on the continued development and commercialization of Back-Step Blockchain. Our work combines secure hardware, embedded systems, server software, and practical application design.
            </p>
            <p>
              Encryption Technology Pte. Ltd. is our sister company and supports hardware production with long experience in professional network encryption.
            </p>
          </div>
          <div className={styles.photoPanel}>
            <img src={chainImage} alt="Large blockchain chain concept" />
          </div>
        </div>
      </section>

      <section className={styles.sectionAlt}>
        <div className={styles.sectionInner}>
          <div className={styles.sectionHeader}>
            <span className={styles.tag}>What we provide</span>
            <h2>Practical routes to launch trusted products.</h2>
            <p>
              Customers and partners can start with our services, build applications on our generators, or license the technology for their own products.
            </p>
          </div>
          <div className={styles.grid}>
            <article className={styles.card}>
              <div className={styles.cardBody}>
                <span className={styles.tag}>Services</span>
                <h3>Trust.it applications</h3>
                <p>Use Back-Step Blockchain as a hosted service for tamper-resistant records, product certificates, and customer-facing trust workflows.</p>
              </div>
            </article>
            <article className={styles.card}>
              <div className={styles.cardBody}>
                <span className={styles.tag}>Products</span>
                <h3>Generator hardware</h3>
                <p>Build dedicated blockchain servers with hardware modules, drivers, APIs, and partner support for custom applications.</p>
              </div>
            </article>
            <article className={styles.card}>
              <div className={styles.cardBody}>
                <span className={styles.tag}>Licensing</span>
                <h3>Embedded trust</h3>
                <p>Integrate Back-Step Blockchain into products such as secure devices, recorders, wallets, and identity systems.</p>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.split}>
          <div className={styles.photoPanel}>
            <img src={officeImage} alt="Office workspace" />
          </div>
          <div className={styles.splitCopy}>
            <span className={styles.tag}>Company details</span>
            <h2>Impressum</h2>
            <p>
              Blockchain Systems Pte. Ltd., Singapore, CRN 201832149D. Contact: info@blockchainsystems.vip.
            </p>
            <p>
              Copyright {currentYear} by Blockchain Systems Pte. Ltd. All rights reserved. Back-Step Blockchain is patented in multiple jurisdictions.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
